import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import { UPDATE_ADMIN } from "../../../../graphql/mutations/management";
import { FETCH_ADMIN } from "../../../../graphql/queries/management";
import {
  clearAdminForm,
  onChangeAdminUpdateForm,
  toggleAdminUpdateModal,
} from "../../redux/adminSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const AdminUpdateForm = () => {
  const dispatch = useDispatch();
  const { updateForm } = useSelector((state) => state.admin);

  const [updateAdmin, { loading }] = useMutation(UPDATE_ADMIN, {
    refetchQueries: [{ query: FETCH_ADMIN }],
    onCompleted: ({ updateAdmin }) => {
      if (updateAdmin) {
        dispatch(toggleAdminUpdateModal());
        showSuccessToast();
        dispatch(clearAdminForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    updateAdmin({
      variables: {
        id: updateForm.id,
        input: {
          fullname: updateForm.fullname,
          email: updateForm.email,
        },
      },
    });
  };

  const handleChange = (e) => {
    dispatch(
      onChangeAdminUpdateForm({
        ...updateForm,
        [e.target.name]: e.target.value,
      })
    );
  };

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ເຕັມ"
        name="fullname"
        onChange={handleChange}
        type="text"
        value={updateForm?.fullname}
        errorParam="name"
        required={true}
      />
      <CustomFormGroup
        label="email"
        name="email"
        onChange={handleChange}
        type="text"
        value={updateForm?.password}
        required={true}
      />

      <div className="text-center">
        <SubmitButton loading={loading} />
      </div>
    </Form>
  );
};

export default AdminUpdateForm;
